import { FunctionCard, FunctionCards } from '@/shared/components';
const DOCUMENTS_IMAGE = '/assets/pricing/documents/quote-papers.webp';
const PAYMENT_METHODS_IMAGE = '/assets/pricing/documents/payment-methods.webp';
const CUSTOM_ORDER_IMAGE = '/assets/pricing/documents/custom-order.webp';
const TITLE_COLOR = 'text-[#77460B]';

/**
 * 요금제 기능 비교표 아래 — "학교 제출용 서류" 안내 섹션.
 * 레이아웃은 랜딩 Teacher/Students 섹션과 동일한 FunctionCards(상단 가로 1 + 하단 세로 2).
 * isKR 전용 (호출부에서 게이팅).
 */
export const SchoolDocumentsSection = () => {
  return <section className="px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:px-[40px] min-[1025px]:py-3xl" data-sentry-component="SchoolDocumentsSection" data-sentry-source-file="SchoolDocumentsSection.tsx">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-lg min-[751px]:items-stretch min-[751px]:gap-2xl">
        <h2 className="px-[16px] text-center text-display-sm-extrabold text-default">
          <span className="bg-gradient-to-r from-[#8478FF] to-[#3DA9FF] bg-clip-text text-transparent">
            학교 제출용 서류
          </span>{' '}
          걱정하지 마세요
        </h2>
        <FunctionCards topElement={<DocumentsCard />} bottomLeftElement={<PaymentCard />} bottomRightElement={<CustomOrderCard />} data-sentry-element="FunctionCards" data-sentry-source-file="SchoolDocumentsSection.tsx" />
      </div>
    </section>;
};
const DocumentsCard = () => <FunctionCard.HorizontalWrapper className="max-w-none bg-yellow-50" data-sentry-element="unknown" data-sentry-component="DocumentsCard" data-sentry-source-file="SchoolDocumentsSection.tsx">
    <div className="flex-1">
      <div className="flex size-full flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pr-0 min-[1025px]:p-3xl min-[1025px]:pr-0">
        <FunctionCard.Title className={TITLE_COLOR} data-sentry-element="unknown" data-sentry-source-file="SchoolDocumentsSection.tsx">
          견적서부터 행정서류까지, <br />
          학교에 필요한 모든 서류를 제공합니다
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="SchoolDocumentsSection.tsx">
          학교 운영에 필요한 견적서, 세금계산서, 행정 서류 등 <br />
          맞춤형 서류를 신속히 지원합니다.
        </FunctionCard.Description>
      </div>
    </div>
    <div className="flex-1 min-[751px]:h-[310px] min-[1025px]:h-[374px]">
      <img src={DOCUMENTS_IMAGE} alt="학교 제출용 서류" className="size-full min-[751px]:object-cover min-[751px]:object-left" />
    </div>
  </FunctionCard.HorizontalWrapper>;
const PaymentCard = () => <FunctionCard.VerticalWrapper className="max-w-none bg-yellow-100" data-sentry-element="unknown" data-sentry-component="PaymentCard" data-sentry-source-file="SchoolDocumentsSection.tsx">
    <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
      <FunctionCard.Title className={TITLE_COLOR} data-sentry-element="unknown" data-sentry-source-file="SchoolDocumentsSection.tsx">
        필요한 결제 방식을 <br />
        자유롭게 선택하세요
      </FunctionCard.Title>
      <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="SchoolDocumentsSection.tsx">
        카드 결제, 통장 입금부터 학교장터, 나라장터, 아이스크림몰까지 <br />
        학교에 맞는 방식으로 편리하게 결제하세요.
      </FunctionCard.Description>
    </div>
    <img src={PAYMENT_METHODS_IMAGE} alt="결제 수단" className="w-full" />
  </FunctionCard.VerticalWrapper>;
const CustomOrderCard = () => <FunctionCard.VerticalWrapper className="max-w-none bg-[#F7F6F0]" data-sentry-element="unknown" data-sentry-component="CustomOrderCard" data-sentry-source-file="SchoolDocumentsSection.tsx">
    <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
      <FunctionCard.Title className={TITLE_COLOR} data-sentry-element="unknown" data-sentry-source-file="SchoolDocumentsSection.tsx">
        필요한 기간과 예산만큼 <br />
        맞춤형 주문이 가능합니다
      </FunctionCard.Title>
      <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="SchoolDocumentsSection.tsx">
        학교별 예산과 운영 방식에 맞춰 <br />
        원하는 기간과 규모로 결제할 수 있습니다.
      </FunctionCard.Description>
    </div>
    <img src={CUSTOM_ORDER_IMAGE} alt="맞춤형 주문" className="w-full" />
  </FunctionCard.VerticalWrapper>;